module.exports = __webpack_public_path__ + "img/cloud.1583eb21.png";